<script>
export default {
  name: "None"
};
</script>

<template>
  <div>
    <div id="page">
      <main role="main">
        <slot />
      </main>
    </div>
    <div id="modales">
    </div>
  </div>
</template>

<style scoped lang="scss">
</style>